
import { Options } from "vue-class-component";
import BaseForm from "../../baseForm/baseForm.vue";
import { FormGroup } from "../../../model/FormGroup.model";
@Options({})
export default class Timer extends BaseForm {
  public timer = 30;
  public formGroup: FormGroup = {
    timer: {
      rules: [],
      value: this.timer
    }
  };
}
